import React, { FC } from 'react'

import { useTheme } from '@mui/material'
import Box from '@mui/material/Box'

export const CustomHorizontalChart: FC<{
  positive: number
  negative: number
}> = ({ positive, negative }) => {
  const { spacing, palette } = useTheme()

  const positiveAbs = Math.abs(Number(positive))
  const negativeAbs = Math.abs(Number(negative))

  const max = Math.max(positiveAbs, negativeAbs)
  const positiveWidth = (positiveAbs / max) * 100
  const negativeWidth = (negativeAbs / max) * 100

  return (
    <Box display="flex" flexDirection="column" gap={spacing(1)} width="100%">
      <Box
        sx={{ width: `${positiveWidth}%`, height: spacing(1), backgroundColor: palette.green[400] }}
      />
      <Box
        sx={{ width: `${negativeWidth}%`, height: spacing(1), backgroundColor: palette.red[400] }}
      />
    </Box>
  )
}
